import styled from '@emotion/styled';
import { Tooltip } from '@material-ui/core';
import CloudDownload from '@material-ui/icons/CloudDownload';
import { createElement, FC } from 'react';
import { FormattedMessage } from 'react-intl';

import ButtonWithIcon from '../../primitive/ButtonWithIcon';

interface Props {
  label: string;
  tooltip?: string;
  onClick: () => void;
  disabled: boolean;
  align?: 'right' | 'left';
}

const BatchDownloadButton: FC<Props> = ({ ...props }) => {
  let StyledSpan;
  switch (props.align) {
    case 'right':
      StyledSpan = RightAlignedSpan;
      break;
    case 'left':
      StyledSpan = LeftAlignedSpan;
      break;
    default:
      StyledSpan = styled('span')();
      break;
  }

  const button = (
    <StyledSpan>
      <ButtonWithIcon
        icon={CloudDownload}
        color="primary"
        variant="contained"
        style={props.disabled ? { pointerEvents: 'none' } : {}}
        {...props}
      >
        <FormattedMessage id={props.label} />
      </ButtonWithIcon>
    </StyledSpan>
  );

  return props.disabled && props.tooltip ? (
    <FormattedMessage id={props.tooltip}>
      {(text: string) => (
        <Tooltip title={text} placement="top">
          {button}
        </Tooltip>
      )}
    </FormattedMessage>
  ) : (
    button
  );
};

const RightAlignedSpan = styled('span')({
  marginLeft: 'auto',
});

const LeftAlignedSpan = styled('span')({
  marginRight: 'auto',
});

export default BatchDownloadButton;
